import React, { useEffect, useRef, useState } from "react";
import { notificationImages, post } from "../../config/imagesLink";
import DescriptionIcon from '@mui/icons-material/Description';
import { Tooltip } from "@mui/material";
import {
  Table,
  Card,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../Navigation/Header";
import LeftNavigation from "../Navigation/LeftNavigation";
import ReactSelect from "react-select";
import axios from "../../API/axios";
import moment from "moment";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import HiringStatus from "./HiringStatus";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
import { ShimmerDiv } from "@skeleton";
import { useTranslation } from "react-i18next";

// import { Link } from 'react-router-dom'
const Interview = () => {
  const navigate = useNavigate();
    const location = useLocation();
 const { t } = useTranslation();

  const sessionId = localStorage.getItem("sessionId");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  //************************Job Application Start  ************************//
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorImage, setErrorImage] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [jobApplication, setJobApplication] = useState([]);
 
  const isFetching = useRef(false)
      const language = localStorage.getItem("Lang");


  // const getJobApplication = async(page) => {
  //   	if (isFetching.current) return; // Prevent duplicate
	// 	isFetching.current = true;
	// 	setLoading(true);

  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     pageNumber: page,
  //     pageSize: 12
  //   };
    
  //   	try {
	// 		const response = await axios.post(`ManageJob/GetAllInterviews`, data);
	// 		const newPosts = response.data.responseData.jobsList || [];
  //       if (response.status === 204 || response.status === 404) {
  //         setErrorImage(true);
  //       } else {

	// 		setTotalPages(response.data.responseData.paging.totalPages || 1);

	// 		setJobApplication((prev) => {
	// 			const postSet = new Set(prev.map((post) => post.jobId));
	// 			const uniqueNewPosts = newPosts.filter((post) => !postSet.has(post.jobId));
	// 			return [...prev, ...uniqueNewPosts];
	// 		});
  //     }
	// 		setError(false);
	// 	} catch (error) {
	// 		console.error(error);
	// 		setError(true);
	// 	} finally {
	// 		setLoading(false);
	// 		isFetching.current = false;
	// 	}
  // };

    const getJobApplication = async (page) => {
    if (isFetching.current) return; // Prevent duplicate calls
    isFetching.current = true;

    setLoading(true);
    setError(false); // reset error at start

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 12,
      langKey: language === "en" ? "" : language,

    };

    try {
      const response = await axios.post(`JobApplication/GetAllInterviews`, data);
      console.log("errrrrrr", response);
      

      if (response.status === 204 || response.status === 404) {
        setErrorImage(true);
        setJobApplication([]); // optional: clear data
      } else {
        const newPosts = response.data?.responseData?.interviewsList || [];
        setTotalPages(response.data?.responseData?.paging?.totalPages || 1);

        setJobApplication((prev) => {
          const postSet = new Set(prev.map((post) => post.jobId));
          const uniqueNewPosts = newPosts.filter(
            (post) => !postSet.has(post.jobId)
          );
          return [...prev, ...uniqueNewPosts];
        });
      }
    } catch (error) {
      console.error(error);
      setErrorImage(true);
    } finally {
      setLoading(false);
      isFetching.current = false;
    }
  };

  useEffect(() => {
    if (page <= totalPages) {
      getJobApplication(page);
    }
  }, [page]);

  const handleInfiniteScroll = async () => {
   
    if (
			window.innerHeight + document.documentElement.scrollTop + 10 >=
			document.documentElement.scrollHeight &&
			!loading &&
			page < totalPages
		) {
			setPage((prev) => prev + 1);
		}
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, [loading,totalPages]);

  //************************Job Application End  ************************//


  const [interviewModal, setInterviewModal] = useState(false)
  const [interviewDetails, setInterviewDetails] = useState('')


  // change page scroll top
  
       useEffect(() => {
        if (location.pathname === "/Interview") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
        }, [location.pathname]);
       
      const cleanShortDescription = (htmlString) => {
        return htmlString
          ?.replace(/<h3>/gi, "<div>")
          ?.replace(/<\/h3>/gi, "</div>")
          ?.replace(/<strong>/gi, "")
          ?.replace(/<\/strong>/gi, "");
      };

  return (
    <>
      <div className="jobHeader p-3 d-flex justify-content-between">
        <div className="friendsHeaderText">
            
          <h1>  {t("Job Application.Interviews")} </h1>
        </div>
        <a
          className="linkSearch f-14 d-flex align-items-center  pointer"
          onClick={() => navigate('/JobApplications')}
        >
          <ArrowBackSharpIcon className="material-symbols-sharp" />
           {t("Job Application.Job Applications")}
        </a>
      </div>
      {errorImage ? 
        <div className="mt-2 text-center"> 
            <img src={post.errorSmall} alt="404 Not Found" width={300} />       
        </div> 
      :
             <div className="ProfileInner new-ProfileInner">
                {loading ? (
                  <>
                    <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                    <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                    <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  </>
                ) : (
                <>
                  <div className="job-notification-main-container Newjob-notification-main-container">
                    <div className="job-notification-card">
                      <Card className="transaction-table vh-100">
                        <Table responsive className="notification-table table-bordered">
                          <thead style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                            <tr className="f-12 f-600 table-header"> 
                               <th> {t("Job Application.Candidates Name")}</th> 
                                <th>  {t("Job Application.Job Description")}</th>
                                <th> {t("Job Application.Apply On")}</th>  
                              <th>{t("Job Application.Status")}</th>
                              <th>{t("Job Application.CV")}</th> 
                            </tr>
                          </thead>
                          <tbody>
                            {jobApplication &&
                              jobApplication?.map((item, index) => {
                                console.log("get job item", item);
                                return (
                                  <tr >
                                    <td className="row-gap">
                                      <div className="card-image-text d-flex align-items-center">
                                        <div className="card-image me-1">
                                          <img
                                            src={item?.userProfilePic}
                                            alt=""
                                            srcset=""
                                            width={40}
                                            height={40}
                                            style={{ borderRadius: '50%' }}
                                          />
                                        </div>
                                        <div>
                                          {/* <ul>
                                          <li> */}
                                          <Link
                                            to={`/User/${item.userUid}`}
                                            tag="a"
                                            // onClick={(e) => e.preventDefault()}
                                            target="blank"
                                          >
                                            <div className="card-text f-14 f-500 d-flex">
                                              {item?.userName}
                                            </div>
                                            <div className="card-text f-14 f-500 d-flex">
                                              {item?.userCurrentDesignation}
                                            </div>
                                          </Link>

                                        </div>
                                      </div>
                                    </td>
                                    <td className="w-20">
                                      {" "}
                                      <div className="job-desc-text f-14 f-400 ">

                                        {/* <Link
                                          className="job-desc-text "
                                          to={`/JobDetail/${item.jobId}`} target="_blank"> */}
                                        {item?.jobTitle}
                                        {/* <small className="d-block f-10">
                                          {item?.shortDescription}
                                          </small> */}
                                          <div
                                              dangerouslySetInnerHTML={{
                                                __html: cleanShortDescription(
                                                  item.shortDescription?.length > 50
                                                    ? item.shortDescription?.slice(0, 50) + "..."
                                                    : item.shortDescription
                                                ),
                                              }}
                                              style={{ fontSize: "12px", lineHeight: "1.5" }}
                                            />
                                        <button
                                          className="wljSecondaryBtn mt-2"
                                          style={{ width: '120px' }}
                                          onClick={() =>
                                            navigate(`/JobDetail/${item.jobId}`)
                                            //  to={`/JobDetail/${item.jobId}`} target="_blank"
                                          }
                                        >  
                                          {t("Job Application.Job Detail")}
                                        </button>

                                        {/* </Link> */}

                                      </div>
                                    </td>
                                    <td>
                                      <div className="apply-on-text f-14 f-400">
                                        {/* Jun 21, 2019 */}
                                        {moment(item.appliedTime).format('ll')}
                                      </div>
                                    </td>
                                    <td>
                                      <HiringStatus item={item} />
                                      <button
                                        className="wljSecondaryBtn mt-2"
                                        style={{ width: '120px' }}
                                        onClick={() => {
                                          setInterviewModal(true)
                                          setInterviewDetails(item)
                                        }}
                                      > 
                                      {t("Job Application.Interview Detail")} 
                                      </button>
                                    </td>
                                    {/* <td>
                                      {" "}
                                      <div className="recent-work d-flex align-items-center">

                                        <div className="recent-text f-14 f-400">
                                          {item?.remark}
                                        </div>
                                      </div>
                                    </td> */}
                                    <td>
                                      {" "}
                                      <div className="actions-cont">
                                        <ul className="d-flex justify-content-center mb-0 p-0">
                                          <li className="me-2 Icon">
                                            <Link to={`/Resume/${item.userUid}`} target="_blank">
                                              {/* <img
                                                src={notificationImages.notifyImg4}
                                                alt=""
                                                srcset=""
                                              /> */}
                                              <Tooltip title={t("Newsfeed.View Resume")} arrow>
                                                <DescriptionIcon />
                                                </Tooltip>
                                            </Link>
                                          </li>

                                        </ul>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })}
                          </tbody>
                        </Table>
                      </Card>
                    </div>
                  </div>
                  </>
                )} 
      </div>

        }
      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />


      {interviewModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Job Application.Interview Details")}</h6>  
 
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setInterviewModal(false);
                  }}
                />
              </div>
              <Row>
                <Col md={12}>
                  <div className="jobdata-content-cont d-flex flex-column p-3 pb-0">
                    {/* <h6>Company Details</h6> */}

                    <p className="fw-bold d-flex w-100"><img src={interviewDetails.compLogo} width={50} height={50} />
                      <div>
                        <p className="ms-2 fw-bold">{interviewDetails.compName}</p>
                        <p className="ms-2">{interviewDetails.jobTitle}</p>
                        <p className="ms-2">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: cleanShortDescription(
                                  interviewDetails.shortDescription?.length > 60
                                    ? interviewDetails.shortDescription?.slice(0, 60) + "..."
                                    : interviewDetails.shortDescription
                                ),
                              }}
                              style={{ fontSize: "12px", lineHeight: "1.5" }}
                            />
                        </p>
                      </div>
                    </p>
                    </div>
                  <div className="jobdata-content-cont d-flex flex-column p-3 pb-0">
                  {interviewDetails.hiringStatusName === "" || interviewDetails.hiringStatusName === null ? "" : 
                    <p className="fw-bold d-flex w-100"> {t("Job Application.Hiring Status")} : <p className="ms-2">{interviewDetails.hiringStatusName}</p> </p>
                  }
                  {interviewDetails.intrvwPlaceDetails === "" || interviewDetails.intrvwPlaceDetails === null ? "" : 
                    <p className="fw-bold d-flex w-100">{t("Job Application.Place Details")} : <p className="ms-2">{interviewDetails.intrvwPlaceDetails}</p> </p>
                   }
                    {interviewDetails.intrvwPlaceType === ""  || interviewDetails.intrvwPlaceType === null ? "" : 
                    <p className="fw-bold d-flex">{t("Job Application.Place Type")} : <p className="ms-2">{interviewDetails.intrvwPlaceType}</p> </p>
                   }
                    {interviewDetails.scheduleTime === "" || interviewDetails.scheduleTime === null ? "" : 
                    <p className="fw-bold d-flex">{t("Job Application.Schedule Time")} : <p className="ms-2">{moment(interviewDetails.scheduleTime).format("MMMM D, YYYY, hh:mm A")}</p> </p>
                   }
                    {interviewDetails.remark === "" || interviewDetails.remark === null ? "" : 
                    <p className="fw-bold d-flex" >{t("Job Application.Remark")} : <p className="ms-2 remark">{interviewDetails.remark}</p> </p>
                  }
                  </div>
                </Col>
              </Row>

              {/* <div className="text-center mt-2">
                <button
                  color=""
                  className="mainBtn1"
                  onClick={() => {
                    setInterviewModal(false);
                  }
                  }
                >
                  Close
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default Interview;
